<template>
  <div>
    <span :id="`${id}`">
      {{ value ? huggedText(value, 20) : '-' }}
    </span>
    <b-tooltip v-if="value && value.length > 20" :target="`${id}`" placement="topright">
      <span>{{ value }}</span>
    </b-tooltip>
  </div>
</template>
<script>
import { Helper } from '@/mixin/helper'

export default {
  props: {
    value: {
      type: String,
    },
    id: {
      type: String,
      required: true,
    },
  },
  mixins: [Helper],
}
</script>
